import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { BACKDOOR_TOKEN_KEY } from '@/shared/constants/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const [isChecking, setIsChecking] = useState(true);
  const [hasToken, setHasToken] = useState(false);

  useEffect(() => {
    // Check for backdoor token on mount (sessionStorage first, then localStorage for PWA)
    const backdoorToken =
      sessionStorage.getItem(BACKDOOR_TOKEN_KEY) || localStorage.getItem(BACKDOOR_TOKEN_KEY);

    setHasToken(!!backdoorToken);
    setIsChecking(false);
  }, []);

  if (isChecking) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        gap={2}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Vérification de l'authentification...
        </Typography>
      </Box>
    );
  }

  if (!hasToken) {
    return <Navigate to="/error" replace />;
  }

  return <>{children}</>;
}
